import { combineReducers } from 'redux';
import sessionReducer from './sessionReducer';
import companyReducer from './companyReducer';
import subsidiariesReducer from './subsidiariesReducer';
import customSettingsReducer from './customSettingsReducer';

const appReducer = combineReducers({
  session: sessionReducer,
  company: companyReducer,
  companySubsidiaries: subsidiariesReducer,
  companyCustomSettings: customSettingsReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'SESSION_LOGOUT') {
    const { session } = state;
    state = { session };
  }
  return appReducer(state, action);
};

export default rootReducer;
